export const CA_STRIPE_KEY = process.env.REACT_APP_STRIPE_CA;
export const TX_STRIPE_KEY = process.env.REACT_APP_STRIPE_TX;
export const TPC_STRIPE_KEY = process.env.REACT_APP_STRIPE_TPC;
export const TNJ_STRIPE_KEY = process.env.REACT_APP_STRIPE_TNJ;
export const STC_STRIPE_KEY = process.env.REACT_APP_STRIPE_STC;